export const collection = 'cms_carcase_subcategory';
